export default {
    fields: [
        {
            key: "fieldName",
            label: "field",
            sorter: false,
            filter: false,
            _style: 'width:25%',
        },
        {
            key: "fieldType",
            label: "field_type",
            sorter: false,
            filter: false,
            _style: 'width:10%',
        },
        {
            key: "condition",
            label: "expression",
            sorter: false,
            filter: false,
            _style: 'width:25%',
        },
        {
            key: "value",
            label: "validation",
            sorter: false,
            filter: false,
            _style: 'width:30%',
        },
        {
            key: "options",
            label: "options",
            sorter: false,
            filter: false,
            _style: 'width:10%',
        },
    ],
    items: [],
    hover: true,
    border: true,
    striped: true,
    addTableClasses: [
        'table--sm'
    ]
}